/*!

=========================================================
* Crypto Exchange Front platform - v1.0.0
=========================================================

* Copyright @2020 Hermes team

* Coded by Hermes team

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from "vue";
import DashboardPlugin from "./plugins/dashboard-plugin";
import App from "./App.vue";
import router from "./router";
import VueRouter from "vue-router";
import store from "./store";
import { CoolSelectPlugin } from "vue-cool-select";
// paste the line below only if you need "bootstrap" theme
import "vue-cool-select/dist/themes/bootstrap.css";
// paste the line below only if you need "material-design" theme
import "vue-cool-select/dist/themes/material-design.css";
import VueCountdown from "@chenfengyuan/vue-countdown";
import VuePersianDatetimePicker from "vue-persian-datetime-picker";
import VueSweetalert2 from "vue-sweetalert2";

// If you don't need the styles, do not connect
import "sweetalert2/dist/sweetalert2.min.css";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

Vue.component("v-select", vSelect);
Vue.component("date-picker", VuePersianDatetimePicker);
Vue.component(VueCountdown.name, VueCountdown);

import * as persianTools from "persian-tools2";

// plugin setup
Vue.use(VueSweetalert2);
Vue.use(DashboardPlugin);
Vue.use(VueRouter);
Vue.use(CoolSelectPlugin);

Vue.config.productionTip = false;
const ENV = process.env.ENV || "";

require("dotenv").config({
  path: `${process.cwd()}/.env${
    typeof ENV !== "undefined" ? ENV.toLowerCase() : ""
  }`,
  debug: typeof ENV !== "undefined" && ENV === "development",
});

const token = localStorage.getItem("user-token");
if (token) {
  Vue.prototype.$http.defaults.headers.common["Authorization"] = token;
}

Number.prototype.toFixedNoRounding = function (n) {
  const reg = new RegExp("^-?\\d+(?:\\.\\d{0," + n + "})?", "g");
  const a = this.toString().match(reg)[0];
  const dot = a.indexOf(".");
  if (dot === -1) {
    // integer, insert decimal dot and pad up zeros
    return a + "." + "0".repeat(n);
  }
  const b = n - (a.length - dot) + 1;
  return b > 0 ? a + "0".repeat(b) : a;
};

const unixToDateTime = (unixTime) => {
  const milliseconds = unixTime * 1000;
  const dateObject = new Date(milliseconds);
  const humanDateFormat = dateObject.toLocaleString();
  return humanDateFormat;
};

const date_diff_indays = (date1, date2) => {
  const d1 = new Date(unixToDateTime(date1));
  const d2 = new Date(date2);
  const diffTime = Math.abs(d2 - d1);
  const diffH = Math.ceil(diffTime / (1000 * 60));
  return diffH;
};



Vue.mixin({
  methods: {
    // getNotificationMessage(message) {
    //   if (message.type == 'LoginRequest') {
    //     return 'ورود به سیستم'
    //   }
    //   else if (message.type == 'DocumentApproval') {
    //     return 'تایید مدارک احراز هویت'
    //   }
    //   else if (message.type == 'Deposit') {
    //     return 'واریز'
    //   }
    //   else if (message.type == 'Withdraw') {
    //     return 'برداشت'
    //   }
    // },
    fixFloat(num) {
      return num.toString().match(/^-?\d+(?:\.\d{0,7})?/)[0];
    },

    numberWithCommas(n) {
      const number = n.toLocaleString("en-US");
      //trailing zeros
      return number.replace(/(\.\d*?[1-9])0+$/g, "$1");
    },

    fixDecimal(n) {
      const num = Number.isInteger(n * 1) ? n * 1 : this.fixFloat(n);

      return this.numberWithCommas(num);
    },

    fixDate(date) {
      const d = new Date(date);
      return d.setSeconds(d.getSeconds() + 210 * 60);
    },

    getLevelName(level) {
      if (level) {
        if (level == "Admin") {
          return "کاربر مدیر";
        }

        if (level == "Trader") {
          return "کاربر تریدر";
        }

        if (level == "UserLevel0") {
          return "کاربر سطح 0";
        }

        if (level == "UserLevel1") {
          return "کاربر سطح 1";
        }

        if (level == "UserLevel2") {
          return "کاربر سطح 2";
        }

        if (level == "UserLevel3") {
          return "کاربر سطح 3";
        }
      }
    },

    redirectTo(link) {
      console.log(link);
      router.push(link);
    },

    errorHandler(err) {
      // console.log(err)
      // console.log(err.response)
      // if (err.response.status == 401) {
      //   store
      //     .dispatch("logout")
      //     .then(() => {
      //       // window.location.replace("/login");
      //       router.push("/login")
      //     })
      //     .catch((err) => {
      //       // console.log(err);
      //     });
      // }
      // if (err.response.status == 400) {
      //   return { variant: "danger", message: "خطا در درخواست" }
      // }
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    toFixedNoRounding(n) {
      const reg = new RegExp("^-?\\d+(?:\\.\\d{0," + n + "})?", "g");
      const a = this.toString().match(reg)[0];
      const dot = a.indexOf(".");
      if (dot === -1) {
        // integer, insert decimal dot and pad up zeros
        return a + "." + "0".repeat(n);
      }
      const b = n - (a.length - dot) + 1;
      return b > 0 ? a + "0".repeat(b) : a;
    },

    updateProfile() {
      store
        .dispatch("getProfile")
        .then((response) => {})
        .catch((err) => {
          // console.log(err);
          if (err.response) {
          } else {
            this.loginMessage =
              "Something went wrong, contact yout adminstrator";
          }
        });
    },

    checkAccess: function (scope) {
      if (!(scope in store.getters.accesslist)) {
        // return false; temp disable
        return true;
      }
      if (store.getters.accesslist[scope] == "*") {
        return true;
      }

      const comm = store.getters.accesslist[scope].filter((value) =>
        store.getters.usermodel.role.includes(value)
      );
      if (comm.length == 0) {
        // return false; temp disable
        return false;
      } else return true;
    },

    toPersianNum(num) {
      return persianTools.digitsEnToFa(num);
    },

    persianToEnglish(num) {
      return persianTools.digitsFaToEn(num);
    },

    openCurtainMenu: function (value) {
      return value;
    },

    addCommas(value) {
      return persianTools.addCommas(value);
    },

    showMessage: function (message, variant) {
      return { message, variant };
    },

    capitalizeFirstLetter: (str) => str.charAt(0).toUpperCase() + str.slice(1),
  },
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  render: (h) => h(App),
  router,
  store,
});


